import styled from "styled-components";

export const DropDownContainer = styled.div`
  margin: 0 auto;
`;

export const DropDownHeader = styled.div`
  display: block;
  width: 180px;
  height: 32px;
  background: #fff;
  border: 2px solid #5c91f5;
  border-radius: 4px;
  text-align: left;
  line-height: 30px;
  padding: 0 16px 0 16px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #5c91f5;

  cursor: pointer;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropDownHeaderArrow = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  background: #5c91f5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropDownListContainer = styled.div`
  position: relative;
  z-index: 2;
  padding-top: 4px;
`;

export const DropDownList = styled.ul`
  border: 2px solid #d5d9dd;
  background: #fff;
  width: 180px;
  max-height: 196px;
  overflow-y: auto !important;
  margin: 0;
  padding: 10px 0;
  display: block;
  border-radius: 4px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
`;

export const DropDownListItem = styled.li`
  list-style: none;
  display: block;
  margin: 0;
  padding: 10px 20px;
  min-height: 36px;
  line-height: 1.2;
  cursor: pointer;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 27, 59, 0.94);

  &:hover {
    background-color: rgba(0, 27, 59, 0.04);
    color: rgba(0, 27, 59, 0.94);
  }

  ${p => p.isSelected && `
    color: #fff;
    background-color: #5c91f5;
  `}
`;

const Styled = {};

Styled.Body = styled.div`
  width: 100%;
  background: #e5e5e5;
  padding: 40px 40px 70px;
  min-height: calc(100vh - 59px);

  .loader {
    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.SurveyDropDown = styled(DropDownHeader)`
  width: 300px;
`;

Styled.SurveyDropDownList = styled(DropDownList)`
  width: 300px;
`;

Styled.AbsoluteListContainer = styled(DropDownListContainer)`
  position: absolute;
`;

Styled.DownloadLink = styled.a`
  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    text-decoration: underline;
    color: #fff;
  }

  &:hover {
    text-decoration: none;
  }
`;

Styled.Title = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);

  ${p =>
    p.marginTop &&
    `
    margin-top: ${p.marginTop};
  `}
`;

Styled.Description = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 15px;
`;

Styled.DescriptionText = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 8px;

  span {
    color: rgb(100, 116, 135);
  }
`;

Styled.Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;

  > div:first-child {
    flex-basis: 760px;
  }

  ${p => !p.isMenuExpanded && `
    > div:first-child {
      flex-basis: 856px;
    }
  `}
`;

Styled.Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;

Styled.Block = styled.div`
  width: 370px;
  height: 280px;

  ${p => !p.isMenuExpanded && `
    width: 418px;
  `}

  ${p => p.twoRowsLength && `
    height: 580px;
  `}

  ${p => p.twoColumnsLength && p.isMenuExpanded && `
    width: 760px;
  `}

  ${p => p.twoColumnsLength && !p.isMenuExpanded && `
    width: 856px;
  `}
`;

Styled.BlockTitle = styled.div`
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  background: #2a4169;
  border-radius: 8px 8px 0 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

Styled.BlockContent = styled.div`
  width: 100%;
  height: calc(100% - 40px);
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.15);
  border-radius: 0 0 8px 8px;
  position: relative;
`;

Styled.BlockScroll = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto !important;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #2a4169;
  }
`;

Styled.BlockHint = styled.div`
  position: absolute;
  top: 12px;
  left: 10px;

  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11.5px;
  line-height: 13px;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.38);
`;

Styled.BlockHintStatus = styled.div`
  position: absolute;
  top: 8px;
  left: 130px;

  display: flex;
  width: 50px;
  height: 20px;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: 1.5px solid #d5d9dd;
  background: #fafafa;

  font-family: Mukta Vaani;
  font-size: 11.5px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
`;

Styled.StudentStatsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 158px;
  height: 32px;
  background: #5c91f5;
  border-radius: 4px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #7ca6f7;
  }
  
  &:disabled {
    border: 1.5px solid #D5D9DD;
    background: #fff;
    color: #001B3B61;

    &:hover {
      background: #fff;
    }
  }
`;

Styled.StudentsErrorContainer = styled.div`
  position: relative;

  .inline-error {
    width: 396px;
    position: absolute;
    bottom: 0;
  }
`;

Styled.Label = styled.p`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2f4166;
  padding: 50px 0 0 19px;
`;

Styled.Engagement = {};

Styled.Engagement.Columns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 71px;
`;

Styled.Engagement.Title = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #fff;

  b {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
  }
`;

Styled.Engagement.Dropdown = styled.div`
  margin-bottom: 10px;
  width: 165px;
  margin-left: -38px;
`;

Styled.Engagement.DropDownHeader = styled(DropDownHeader)`
  width: 165px;
`;

Styled.Engagement.DropDownList = styled(DropDownList)`
  width: 165px;
`;

Styled.Engagement.LeftColumn = styled.div`
  padding: 50px 0 0 19px;
  max-width: 160px;
`;

Styled.Engagement.PercentAmount = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

Styled.Engagement.PercentAmountValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 54px;
  line-height: 100%;
  color: #ec5e59;
`;

Styled.Engagement.PercentAmountPercent = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 100%;
  color: rgba(236, 94, 89, 0.72);
  padding: 19px 0 0 10px;
`;

Styled.Engagement.Description = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2f4166;
`;

Styled.Engagement.RightColumn = styled.div`
  width: 127px;
  padding-top: 10px;
`;

Styled.Engagement.ChartTitle = styled.div`
  position: absolute;
  top: 4px;
  left: 12px;
  z-index: 1;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Engagement.Chart = styled.div`
  position: relative;
  width: 127px;
  height: 48px;
  overflow: hidden;

  .recharts-responsive-container {
    margin-top: -6px;
  }

  .recharts-label-list {
    display: none;
  }

  ${p => p.marginTop && `
    margin-top: ${p.marginTop};
  `}
`;

Styled.Performance = {};

Styled.Performance.Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 70px;
`;

Styled.Performance.LeftColumn = styled.div`
  padding: 50px 0 0 20px;
`;

Styled.Performance.BigPercentValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 54px;
  line-height: 100%;
  color: #72c4cb;
`;

Styled.Performance.PercentLabel = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2f4166;

  ${p => p.marginTop && `
    margin-top: ${p.marginTop};
  `}
`;

Styled.Performance.SmallPercentValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 140%;
  color: #72c4cb;
`;

Styled.Performance.PercentGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 47px;
  margin-top: 16px;
`;

Styled.Performance.RightColumn = styled.div`
  padding-top: 25.5px;
`;

Styled.Performance.RightTitle = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 140%;
  color: #2f4166;
  text-align: center;
`;

Styled.Performance.ButtonsGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 8px;
`;

Styled.Performance.Button = styled.button`
  display: block;
  width: 120px;
  height: 32px;
  background: #fff;
  border: 1.5px solid #2a4169;
  border-radius: 4px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  color: #2a4169;
  text-align: center;
  white-space: nowrap;

  &:disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: not-allowed;
    pointer-events: all !important;
  }
`;

Styled.TeamDynamics = {};

Styled.TeamDynamics.WhiteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  padding-top: 99px;
  padding-left: 37px;
`;

Styled.TeamDynamics.ProcessButton = styled.div`
  display: inline-block;

  width: auto;
  height: 32px;
  background: #5c91f5;
  border-radius: 4px;
  padding: 0 6px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;

  &:hover {
    background-color: #7ca6f7;
  }
`;

Styled.TeamDynamics.UpdateButton = styled.div`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  top: -2px;

  width: 50px;
  height: 20px;
  background: #5c91f5;
  border-radius: 4px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 11.5px;
  line-height: 20px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;

  &:hover {
    background-color: #7ca6f7;
  }
`;

Styled.TeamDynamics.Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 25px;
`;

Styled.TeamDynamics.LeftColumn = styled.div`
  padding: 40px 0 0 25px;
`;

Styled.TeamDynamics.RightColumn = styled.div`
  margin-top: 43px;
`;

Styled.TeamDynamics.BorderedRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  border-right: 1px solid rgba(0, 27, 59, 0.15);
  padding-right: 30px;
`;

Styled.TeamDynamics.LabelsTitle = styled.div`
  font-family: Mukta Vaani;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #2a4169;
  padding-bottom: 11px;
`;

Styled.TeamDynamics.LabelCentered = styled.div`
  font-family: Mukta Vaani;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #2a4169;
  text-align: center;
  padding-top: 88px;
`;

Styled.TeamDynamics.LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
`;

Styled.TeamDynamics.Label = styled.a`
  display: block;

  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #2f4166;
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
  }
`;

Styled.TeamDynamics.LabelIcon = styled.div`
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 100px;

  ${p => p.color && `
    background: ${p.color};
  `}
`;

Styled.SkillSets = {};

Styled.SkillSets.Container = styled.div`
  display: flex;
  padding: 12px;
  height: 100%;
  align-items: center;
  justify-content: center;

  // .recharts-polar-radius-axis .recharts-polar-radius-axis-ticks .recharts-polar-radius-axis-tick:last-child {
  //   display: none;
  // }
`;

Styled.SkillSets.Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 21.5px;
`;

Styled.SkillSets.LeftColumn = styled.div`
  padding: 36.5px 0 0 25px;

  .g-recharts-radar-circle {
    text {
      font-family: 'Mukta Vaani', sans-serif;
      font-weight: 500;
      font-size: 13.5px;
      fill: #fff;
    }
  }
`;

Styled.SkillSets.RightColumn = styled.div`
  padding-top: 57px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`;

Styled.SkillSets.SkillItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

Styled.SkillSets.Label = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #2f4166;
`;

Styled.SkillSets.NumCircle = styled.div`
  width: 18px;
  height: 18px;
  background: #667689;
  border-radius: 100px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 13.5px;
  line-height: 18px;
  text-align: center;
  color: #fff;

  ${p => p.isActive && `
    background: #eca427;
  `}
`;

Styled.SkillSets.Switcher = styled.div`
  display: flex;
  position: absolute;
  top: 12px;
  right: 10px;
  font-family: 'Roboto';
  font-weight: 500;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.38);
  font-size: 11px;
  line-height: 13px;
`;

Styled.SkillSets.SwitcherItem = styled.button`
  padding: 0;

  &:hover {
    color: rgba(0, 27, 59, 0.94);
  }

  ${p => p.isActive && `
    cursor: default;
    pointer-events: none;
    color: rgba(0, 27, 59, 0.94);
  `}
`;

Styled.SkillSets.SwitcherItemDivider = styled.span`
  padding: 0 6px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Leaderboard = {};

Styled.Leaderboard.Table = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 362px;
  margin: 20px auto 0;

  ${p => !p.isMenuExpanded && `
    width: 410px;
  `}
`;

Styled.Leaderboard.Row = styled.div`
  height: 54px;
  width: 362px;
  border-top: 1px solid rgba(0, 27, 59, 0.08);
  background: #fff;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  &:nth-child(1), &:nth-child(2) {
    border-top: none;
  }

  ${p => !p.isMenuExpanded && `
    width: 410px;
  `}

  ${p => p.isIndex1 && `
    background-color: #fdd38a;
  `}

  ${p => p.isIndex2 && `
    background-color: #fce0b0;
  `}

  ${p => p.isIndex3 && `
    background-color: #fbedd5;
  `}
`;

Styled.Leaderboard.Loader = styled.div`
  padding: 30px;
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Leaderboard.SortChar = styled.div`
  display: inline;
  font-size: 12px;
  margin-left: 3px;
`;

Styled.LoadingData = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
`;

Styled.Leaderboard.Column = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  ${p => p.hasShadow && `
    box-shadow: -18px 0px 0px -17px rgba(0, 0, 0, 0.06);
  `}

  ${p => p.hasSort && `
    cursor: pointer;
  `}

  span {
    display: inline-block;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;

  a:active,
  a:visited,
  a:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 27, 59, 0.94);
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  &:nth-child(1) {
    flex-basis: 64px;
    box-shadow: none;
  }

  &:nth-child(2) {
    flex-basis: 128px;
  }

  &:nth-child(3) {
    flex-basis: 90px;
    font-size: 14px;
    line-height: 20px;
  }

  &:nth-child(4) {
    flex-basis: 119px;
  }
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/instructor/styles/dashboard.js